// App.js
import {React,useEffect} from 'react';
import Home from './home'
import Navbar from './navbar';
import AboutUs from './aboutus';
import Services from './service';
import ContactUs from './contact';
import EducationPage from './Education/education';
import FundsPage from './Funds/funds';
import PammPool from './Funds/PammPool';
import BlogApp from './Blog/BlogList'
import MyFxBookData from './Ourapps/myfxbook';
import Agreement from './agreement';
import Questionnaire from './componets/Questionnair';
import VideoBackground from './componets/backgroundvideo';
import UserDetails from './Dashboards/userdetails';
import ConfettiCelebration from './componets/ConfettiCelebration';
import HonCopierPage from './Ourapps/HonCopierPage';
import HonVonScalper from './Ourapps/HonVonScalper';
import Auth from './Auth';
import EnhancedClientDashboard from './Dashboards/userdash';
import AdminDepositManager from './componets/AdminDepositManager';
import { AuthProvider } from './Authcontext';
import SurveyThanks from './componets/thankyou';
import MetaTraderWebsite from './mt5';
import VantaLayout from './componets/vantalayout';
import CoursePage from './Education/python4finance';
import Registration from './registration';
import StatPatternProPage from './Ourapps/Hon-sonar';
import Dashboard from './Ourapps/Journal';
import OurApps from './Ourapps/ourapps';
import HonPropDesk from './HonPropDesk';
import CurriculumPage from './Education/python4financecurriculum';
import EducationDashboard from './Education/EducationDashboard';
import IntroCourse from './Education/IntroCourse';
import AlgoTradingAcademy from './AlgoTradingAcademy';
import InvestRegistration from './componets/Investregistration';
import USDTPayment from './componets/USDTPayment';
import InvestDashboard from './componets/InvestDashboard';
import RegistrationSelection from './RegistrationSelection';
import DashboardSelection from './DashboardSelection';
import ProtectedRoute from './ProtectedRoute'; // ← Import the new component
import FreeToolsDirectory from './FreeToolsDirectory';
import ProTraderFreeTool from './ProTraderFreeTool';
import ProTraderMobileApp from './ProTraderMobileApp';
import HeatmapDirectory from './HeatmapDirectory';
import AdminLearnerDashboard from './Education/AdminLearnerDashboard';
import StockHeatmapPage from './StockHeatmapPage';
import CryptoHeatmapPage from './CryptoHeatmapPage';
import EtfHeatmapPage from './EtfHeatmapPage';
import ForexHeatmapPage from './ForexHeatmapPage';
import VPSPage from './VPSPage';
import HonAiSentinel from './HonAiSentinel';
import KsqProTrader from './Ourapps/KsqProTrader';

import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { Analytics } from "@vercel/analytics/react"
import GoogleAnalytics from './components/GoogleAnalytics';

import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import './App.css';

function App() {
  useEffect(() => {
    document.body.style.overflowY = 'auto';
    document.body.style.height = 'auto';
    document.documentElement.style.overflowY = 'auto';
    document.documentElement.style.height = 'auto';
    console.log("Global body/document styles applied for scrollability.");
  }, []);

  return (
    <Router>
      <AuthProvider> 
        <GoogleAnalytics />
        <Navbar />
        <Routes>
          {/* ✅ PUBLIC ROUTES - No auth required */}
          <Route path="/" element={
            <VantaLayout>
              <Home />
            </VantaLayout>
          } />
          
          {/* PROFESSIONAL PUBLIC ROUTES */}
          <Route path="/about-us" element={
            <VantaLayout>
              <AboutUs />
            </VantaLayout>
          } />

          <Route path="/services" element={
            <VantaLayout>
              <Services />
            </VantaLayout>
          } />

          <Route path="/trading-tools" element={
            <VantaLayout>
              <OurApps />
            </VantaLayout>
          } />
          <Route path="/honpropdesk" element={<HonPropDesk />} />

          <Route path="/contact-us" element={
            <VantaLayout>
              <ContactUs />
            </VantaLayout>
          } />

          <Route path="/free-tools" element={<FreeToolsDirectory />} />
          <Route path="/free-tools/protrader-journal" element={<ProTraderFreeTool />} />
          <Route path="/protrader-journal" element={<ProTraderFreeTool />} />
          <Route path="/free-tools/protrader-app" element={<ProTraderMobileApp />} />
          <Route path="/protrader-app" element={<ProTraderMobileApp />} />

          <Route path="/investment-funds" element={
            <VantaLayout>
              <FundsPage />
            </VantaLayout>
          }/>
          <Route path="/pamm-pool" element={
            <VantaLayout>
              <PammPool />
            </VantaLayout>
          }/>
          <Route path="/education" element={
            <VantaLayout>
              <EducationPage />
            </VantaLayout>
          }/>
          <Route path="/algo-trading-academy" element={
            <VantaLayout>
              <AlgoTradingAcademy />
            </VantaLayout>
          }/>
          <Route path='/blog' element={
            <VantaLayout>
              <BlogApp />
            </VantaLayout>
          } />

          {/* REDIRECTS FOR OLD URLS */}
          <Route path="/about" element={<Navigate to="/about-us" replace />} />
          <Route path="/service" element={<Navigate to="/services" replace />} />
          <Route path="/ourapps" element={<Navigate to="/trading-tools" replace />} />
          <Route path="/contact" element={<Navigate to="/contact-us" replace />} />
          <Route path="/funds" element={<Navigate to="/investment-funds" replace />} />

          {/* TOOLS & DOWNLOADS */}
          <Route path="/tools/performance-tracking" element={<MyFxBookData />} />
          <Route path="/downloads/metatrader5" element={<MetaTraderWebsite />} />
          <Route path="/hon-ai-sentinel" element={<HonAiSentinel />} />

          {/* OLD TOOL REDIRECTS */}
          <Route path="/myfxbook" element={<Navigate to="/tools/performance-tracking" replace />} />
          <Route path="/mt5" element={<Navigate to="/downloads/metatrader5" replace />} />
          {/* EDUCATIONAL COURSES */}
          <Route path="/courses/python-for-finance" element={
            <VantaLayout>
              <CoursePage />
            </VantaLayout>
          } />
          <Route path="/courses/python-curriculum" element={
            <VantaLayout>
              <CurriculumPage/>
            </VantaLayout>
          } />
          
          <Route path="/academy/dashboard" element={
            <ProtectedRoute>
              <EducationDashboard />
            </ProtectedRoute>
          } />
          
          <Route path="/admin/learners" element={
            <ProtectedRoute>
              <AdminLearnerDashboard />
            </ProtectedRoute>
          } />

          <Route path="/academy/course/intro-algo" element={
            <ProtectedRoute>
              <IntroCourse />
            </ProtectedRoute>
          } />

          {/* TRADING TOOLS */}
          <Route path="/tools/copy-trading" element={
            <VantaLayout>
              <HonCopierPage/>
            </VantaLayout>
          } />
          <Route path="/tools/scalping-system" element={
            <VantaLayout>
              <HonVonScalper/>
            </VantaLayout>
          } />
          <Route path="/tools/protrader-suite" element={
            <VantaLayout>
              <KsqProTrader/>
            </VantaLayout>
          } />
          <Route path="/tools/market-analysis" element={<StatPatternProPage />} />
          <Route path="/heatmaps" element={<HeatmapDirectory />} />
          <Route path="/heatmaps/stocks" element={<StockHeatmapPage />} />
          <Route path="/heatmaps/crypto" element={<CryptoHeatmapPage />} />
          <Route path="/heatmaps/etf" element={<EtfHeatmapPage />} />
          <Route path="/heatmaps/forex" element={<ForexHeatmapPage />} />

          {/* VPS HOSTING */}
          <Route path="/vps" element={
            <VantaLayout>
              <VPSPage />
            </VantaLayout>
          } />
          <Route path="/forex-vps" element={
            <VantaLayout>
              <VPSPage />
            </VantaLayout>
          } />

          {/* OLD EDUCATIONAL & TOOL REDIRECTS */}
          <Route path="/python4finance" element={<Navigate to="/courses/python-for-finance" replace />} />
          <Route path="/python4financecurriculum" element={<Navigate to="/courses/python-curriculum" replace />} />
          <Route path="/honcopierpage" element={<Navigate to="/tools/copy-trading" replace />} />
          <Route path="/honvonscalper" element={<Navigate to="/tools/scalping-system" replace />} />
          <Route path="/Hon-sonar" element={<Navigate to="/tools/market-analysis" replace />} />
          <Route path="/protrader" element={<Navigate to="/tools/protrader-suite" replace />} />

          {/* ✅ AUTHENTICATION */}
          <Route path="/login" element={
            <VideoBackground>
              <Auth />
            </VideoBackground>
          } />

          {/* ✅ PROTECTED ROUTES - Require authentication */}

          {/* Registration Selection - Must be logged in to choose service */}
          <Route path="/register/select-service" element={
            <ProtectedRoute>
              <VantaLayout>
                <RegistrationSelection />
              </VantaLayout>
            </ProtectedRoute>
          } />

          {/* Dashboard Selection - Must be logged in */}
          <Route path="/dashboard/select" element={
            <ProtectedRoute>
              <DashboardSelection />
            </ProtectedRoute>
          } />

          {/* OLD AUTH REDIRECTS */}
          <Route path="/auth" element={<Navigate to="/login" replace />} />
          <Route path="/registration-selection" element={<Navigate to="/register/select-service" replace />} />
          <Route path="/dashboard-selection" element={<Navigate to="/dashboard/select" replace />} />
          
          {/* All Registration Routes - Must be logged in */}
          <Route path="/registration" element={
            <ProtectedRoute>
              <VideoBackground>
                <Registration />
              </VideoBackground>
            </ProtectedRoute>
          } />
          
          <Route path="/investregistration" element={
            <ProtectedRoute>
              <VideoBackground>
                <InvestRegistration/>
              </VideoBackground>
            </ProtectedRoute>
          } />
          
          <Route path="/userdetails" element={
            <ProtectedRoute>
              <VideoBackground>
                <UserDetails />
              </VideoBackground>
            </ProtectedRoute>
          } />
          
          <Route path="/register" element={
            <ProtectedRoute>
              <VideoBackground>
                <UserDetails />
              </VideoBackground>
            </ProtectedRoute>
          } />
          
          {/* Payment and Dashboard Routes - Must be logged in */}
          <Route path="/usdtpayment" element={
            <ProtectedRoute>
              <VideoBackground>
                <USDTPayment/>
              </VideoBackground>
            </ProtectedRoute>
          } />
          
          <Route path="/InvestDashboard" element={
            <ProtectedRoute>
              <VideoBackground>
                <InvestDashboard/>
              </VideoBackground>
            </ProtectedRoute>
          } />
          <Route path="/investdashboard" element={<Navigate to="/InvestDashboard" replace />} />
          
          <Route path="/userdash" element={
            <ProtectedRoute>
              <EnhancedClientDashboard />
            </ProtectedRoute>
          } />
          
          <Route path="/thankyou" element={
            <ProtectedRoute>
              <VideoBackground>
                <SurveyThanks />
              </VideoBackground>
            </ProtectedRoute>
          } />
          
          {/* Other Protected Routes */}
          <Route path="/ConfettiCelebration" element={
            <ProtectedRoute>
              <VideoBackground>
                <ConfettiCelebration />
              </VideoBackground>
            </ProtectedRoute>
          } />
          
          <Route path="/agreement" element={
            <ProtectedRoute>
              <VideoBackground>
                <Agreement />
              </VideoBackground>
            </ProtectedRoute>
          } />
          
          <Route path="/Questionnair" element={
            <ProtectedRoute>
              <VideoBackground>
                <Questionnaire />
              </VideoBackground>
            </ProtectedRoute>
          } />
          
          <Route path="/journal" element={
            <ProtectedRoute>
              <VideoBackground>
                <Dashboard />
              </VideoBackground>
            </ProtectedRoute>
          } />
          
          <Route path="/AdminDepositManager" element={
            <ProtectedRoute>
              <AdminDepositManager />
            </ProtectedRoute>
          } />

        </Routes>
        <Analytics />
      </AuthProvider>
    </Router>
  );
}

export default App;
